import { HttpErrorCode } from '@copera/common/error';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SoundBoardData, SoundBoardRequests } from 'src/requests/soundboard';
import { QueryKey } from 'src/utils/react-query';

export const useDeleteSoundMutation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync: deleteSound, isLoading: isDeletingSoundLoading } =
    useMutation(SoundBoardRequests.deleteSound, {
      meta: {
        httpErrors: {
          [HttpErrorCode.INVALID]: 'error.soundboard.invalid_sound_id',
          [HttpErrorCode.NOT_FOUND]: 'error.soundboard.sound_not_found',
          [HttpErrorCode.FORBIDDEN]: 'error.soundboard.not_creator',
        },
      },
      onSuccess(deletedSound) {
        const prevSounds = queryClient.getQueryData<SoundBoardData>([
          QueryKey.SOUNDBOARD,
        ]);

        queryClient.setQueryData<SoundBoardData[]>(
          [QueryKey.SOUNDBOARD],
          (content) => {
            return [
              ...(content || []).filter(
                (sound) => sound._id !== deletedSound._id,
              ),
            ];
          },
        );

        return { prevSounds };
      },
    });

  return {
    deleteSound,
    isDeletingSoundLoading,
  };
};
